export default [
  {
    path: "/project/:proj_id",
    component: () => import("@/layouts/ProjectLayout.vue"),
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: "field/info/:type",
        name: "field-info-type",
        meta: {
          activeCode: "field-info",
        },
        component: () => import("@/views/_BS/FieldInfo.vue"),
      },

      // ========== 사업장(직접수행)
      {
        path: "field/workplace",
        name: "field-workplace-list",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_BS/FieldWorkplaceList.vue"),
      },
      {
        path: "field/workplace/write",
        name: "field-workplace-create",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_BS/FieldWorkplaceWrite.vue"),
      },
      {
        path: "field/workplace/write/:postId",
        name: "field-workplace-update",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_BS/FieldWorkplaceWrite.vue"),
      },
      {
        path: "field/workplace/info",
        name: "field-workplace-info",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_BS/FieldWorkplaceInfo.vue"),
      },

      // ========== 사업장(용역위탁)
      {
        path: "field/workplace2",
        name: "field-workplace2-list",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_BS/FieldWorkplace2List.vue"),
      },
      {
        path: "field/workplace2/write",
        name: "field-workplace2-create",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_BS/FieldWorkplace2Write.vue"),
      },
      {
        path: "field/workplace2/write/:postId",
        name: "field-workplace2-update",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_BS/FieldWorkplace2Write.vue"),
      },
      {
        path: "field/workplace2/info",
        name: "field-workplace2-info",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_BS/FieldWorkplace2Info.vue"),
      },

      // ========== facility
      {
        path: "field/facility",
        name: "field-facility-list",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_BS/FieldFacilityList.vue"),
      },
      {
        path: "field/facility/write",
        name: "field-facility-create",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_BS/FieldFacilityWrite.vue"),
      },
      {
        path: "field/facility/write/:postId",
        name: "field-facility-update",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_BS/FieldFacilityWrite.vue"),
      },
      {
        path: "field/facility/info",
        name: "field-facility-info",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_BS/FieldFacilityInfo.vue"),
      },

      // FieldFacilityBridge
      // {
      //   path: "field/bridge",
      //   name: "field-facility-bridge-list",
      //   meta: {
      //     activeCode: "field-facility-bridge",
      //   },
      //   component: () => import("@/views/_BS/FieldFacilityList.vue"),
      // },
      {
        path: "field/bridge/write",
        name: "field-facility-bridge-create",
        meta: {
          activeCode: "field-facility-bridge",
        },
        component: () => import("@/views/_BS/FieldFacilityBridge.vue"),
      },

      // ========== field
      {
        path: "field/field",
        name: "field-field-list",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_BS/FieldFieldList.vue"),
      },
      {
        path: "field/field/write",
        name: "field-field-create",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_BS/FieldFieldWrite.vue"),
      },
      {
        path: "field/field/write/:postId",
        name: "field-field-update",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_BS/FieldFieldWrite.vue"),
      },
      {
        path: "field/field/info",
        name: "field-field-info",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_BS/FieldFieldInfo.vue"),
      },

      // ========== 창고 ==========
      {
        path: "field/warehouse",
        name: "field-warehouse-list",
        meta: {
          activeCode: "field-warehouse",
        },
        component: () => import("@/views/_BS/FieldWarehouseList.vue"),
      },
      {
        path: "field/warehouse/write",
        name: "field-warehouse-create",
        meta: {
          activeCode: "field-warehouse",
        },
        component: () => import("@/views/_BS/FieldWarehouseWrite.vue"),
      },
      {
        path: "field/warehouse/write/:postId",
        name: "field-warehouse-update",
        meta: {
          activeCode: "field-warehouse",
        },
        component: () => import("@/views/_BS/FieldWarehouseWrite.vue"),
      },
      {
        path: "field/warehouse/info",
        name: "field-warehouse-info",
        meta: {
          activeCode: "field-warehouse",
        },
        component: () => import("@/views/_BS/FieldWarehouseInfo.vue"),
      },

      // ========== 종사자일괄등록 ==========
      {
        path: "employees",
        name: "employees",
        meta: {
          activeCode: "employees",
        },
        component: () => import("@/views/_BS/Employees.vue"),
      },

      // ==========  ==========
      {
        path: "company/info",
        name: "company-info",
        meta: {
          activeCode: "company-info",
        },
        component: () => import("@/views/_BS/CompanyInfo.vue"),
      },
    ],
  },
];
